var config = {
	APIProtocol:"http",
	APIDomainOverride:false,
	APIDomain:"127.0.0.1/prime",
	APIRootPath:"/",
	APIPort:null,
	APIFullURL:function() {
		if (this.APIDomainOverride) {
			return "";
		} else {
			return this.APIProtocol + "://" + this.APIDomain + (this.APIPort ? ":" + this.APIPort : "") + this.APIRootPath;
		}
	},
	APICrossDomain:function() {
		return false;
	},
	AJAXDataType:function() {
		return this.APICrossDomain() ? "jsonp" : "json";
	},
	APITimeout:5000,
	APIUserName:"",
	APIDefaultAJAXRequest: function() {
		var dataType = this.AJAXDataType(),
			timeout = this.APITimeout;
		return {
			cache:false,
			global:true,
			dataType:dataType,
			timeout:timeout,
			success:function(data, textStatus, jqXHR) {
				console.log(data, textStatus, jqXHR);
			},
			error:function(jqXHR, textStatus, errorThrown) {
				console.log(jqXHR, textStatus, errorThrown);
			}
		}
	}
}

var exceptions = {
	DimensionMismatchException:function(wrong, expected) {
		this.message = "Length: " + wrong + ", expected:" + expected
		console.log()
	}
}

var stats = {
	chiSquaredTest:function(expected, observed) {
	    if (expected.length < 2) {
	        throw new exceptions.DimensionMismatchException(expected.length, 2);
	    }
	    if (expected.length != observed.length) {
	        throw new exceptions.DimensionMismatchException(expected.length, observed.length);
	    }
    
		// TODO Check that expected values are all >0 and that observed values are >=0

	    var sumExpected = 0,
	    	sumObserved = 0;
		
	    for (var i = 0; i < observed.length; i++) {
	        sumExpected += expected[i];
	        sumObserved += observed[i];
	    }
	    var ratio = 1.0;
	    var rescale = false;
    
		if (Math.abs(sumExpected - sumObserved) > 10E-6) {
	        ratio = sumObserved / sumExpected;
	        rescale = true;
	    }
	
	    var sumSq = 0.0,
			dev = 0;
	
	    for (var i = 0; i < observed.length; i++) {
	        if (rescale) {
	            dev = observed[i] - ratio * expected[i];
	            sumSq += dev * dev / (ratio * expected[i]);
	        } else {
	            dev = observed[i] - expected[i];
	            sumSq += dev * dev / expected[i];
	        }
	    }
	    return sumSq;
	}
}

var helpers = {
	createFlotTimeSeriesFromArray:function(inputArray, scale) {
		var array = [];
		
		for (var dataPoint in inputArray) {
			array.push([dataPoint, inputArray[dataPoint] * (scale === undefined ? 1 : scale)]);
		}
		
		return array;
	},
	addHTMLToBottomRightOfPlot:function(plot, html) {
		var plotOffset = plot.getPlotOffset();
		plot.getPlaceholder().append("<div style='position:absolute; right:" + (plotOffset.right + 10) + "px; bottom:" + (plotOffset.bottom + 10) + "px;color:#666;font-size:smaller'>" + html + "</div>");
	}
}


var API = {
	retrieveCohort:function(cohortID, successCallback, errorCallback) {
		
	},
	retrieveResult:function(resultID, successCallback, errorCallback) {
		$.ajax({
			url:config.APIFullURL() + "result.json",
			success:function(data, textStatus, jqXHR) {
				if (API.logging) { console.log("Success (result)", data, textStatus, jqXHR) };
				successCallback(data);
			},
			error:function(jqXHR, textStatus, errorThrown) {
				if (API.logging) { console.log("Error (result)", jqXHR, textStatus, errorThrown) };
			    errorCallback({jqXHR:jqXHR, textStatus:textStatus, errorThrown:errorThrown});
			}
		})
	}
}

function addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[0] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}